var _TIMERS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ADD_MAIN_CONTROLS_NAMESPACE, ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE, ADD_OVERLAY_CONTROLS_NAMESPACE, MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSING_ANIMATION, MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSE } from './constants';
var TIMERS = (_TIMERS = {}, _defineProperty(_TIMERS, ADD_MAIN_CONTROLS_NAMESPACE, {
  waitAnimationTimeout: null,
  waitRemovalTimeout: null
}), _defineProperty(_TIMERS, ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE, {
  waitAnimationTimeout: null,
  waitRemovalTimeout: null
}), _defineProperty(_TIMERS, ADD_OVERLAY_CONTROLS_NAMESPACE, {
  waitAnimationTimeout: null,
  waitRemovalTimeout: null
}), _TIMERS);
export var clearNotificationTimeouts = function clearNotificationTimeouts(namespace) {
  // Need to clear any lingering timeouts
  clearTimeout(TIMERS[namespace].waitAnimationTimeout);
  clearTimeout(TIMERS[namespace].waitRemovalTimeout);
};
export var setupNotificationAutoDelay = function setupNotificationAutoDelay(onAnimateClose, onRemove, namespace) {
  // Set a timer for the notification hiding sequence
  // After 7 seconds the animation will play
  // At 8 seconds the notification is removed
  TIMERS[namespace].waitAnimationTimeout = setTimeout(function () {
    onAnimateClose(function () {
      TIMERS[namespace].waitRemovalTimeout = setTimeout(function () {
        onRemove();
      }, MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSE);
    });
  }, MILLISECONDS_TO_DELAY_NOTIFICATION_CLOSING_ANIMATION);
};